import useSignIn from 'containers/authentication/useSignIn'
import useConnectProvider from 'containers/authentication/useConnectProvider'
import useStorage from 'containers/useStorage'
import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const GoogleRedirect = () => {
    const history = useHistory()
    const location = useLocation()
    const storage = useStorage()

    const { signInError, signInWithGoogle } = useSignIn()
    const { connectProvider } = useConnectProvider()

    useEffect(() => {
        // Google uses hash fragment for implicit flow
        const hashParams = new URLSearchParams(location.hash.substring(1))
        const tokenId = hashParams.get('id_token')
        const accessToken = hashParams.get('access_token')

        if (!tokenId && !accessToken) {
          history.push('/sign-in?error=oauth_failed')
          return
        }

        const googleCredentials = accessToken
          ? { google_access_token: accessToken }
          : { google_id_token: tokenId! }

        // Check if this is a provider connection flow
        const intent = localStorage.getItem('oauth_intent')
        const provider = localStorage.getItem('oauth_provider')

        if (intent === 'connect_provider' && provider === 'google') {
          // Clear intent flags
          localStorage.removeItem('oauth_intent');
          localStorage.removeItem('oauth_provider');

          // Call provider connection endpoint
          (async () => {
            const success = await connectProvider(googleCredentials)
            if (success) {
              const returnUrl = storage.getUrlWhenLoggedIn()
              storage.removeUrlWhenLoggedIn()
              history.push(returnUrl || '/settings/providers')
            } else {
              history.push('/settings/providers?error=connection_failed')
            }
          })()
          return
        }

        // Normal sign-in flow
        (async () => {
          if (!(await signInWithGoogle(googleCredentials))) {
            history.push({
              pathname: '/sign-up',
              state: { googleAccessToken: accessToken || tokenId },
            })
          } else {
            history.push('/')
          }
        })()
    }, [])

  return <></>
}

export default React.memo(GoogleRedirect)
